import api from "./api";

const BASE = "/v1/auth";

const getUsers = () => api.get(`${BASE}/getUsers`).then((r) => r.data);
const getUserById = (id) =>
  api.get(`${BASE}/getUserById/${id}`).then((r) => r.data);
const createUser = (payload) =>
  api.post(`${BASE}/register`, payload).then((r) => r.data);
const updateUser = (id, payload) =>
  api.put(`${BASE}/users/${id}`, payload).then((r) => r.data);

export default {
  getUsers,
  getUserById,
  createUser,
  updateUser,
};
